var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#80959D",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.404 11.455L10.935 1M.404 1l10.531 10.455"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconBlack);
export default __webpack_public_path__ + "static/media/close-icon-black.31594047310ab66afd0b516b6f64c6f6.svg";
export { ForwardRef as ReactComponent };